"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/file-gif.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M14 3l5.4 5.4v10.8a1.8 1.8 0 01-1.8 1.8H6.8A1.8 1.8 0 015 19.2V4.8C5 3.801 5.801 3 6.8 3H14zm-.9 6.3h4.95L13.1 4.35V9.3zm-5.185 7.784c0 .133.044.24.134.324.09.083.204.124.343.124a.49.49 0 00.346-.124.42.42 0 00.135-.324.426.426 0 00-.137-.328.487.487 0 00-.344-.126.483.483 0 00-.341.126.426.426 0 00-.136.328zm1.576-1.192v.035c0 .492.117.887.353 1.185.235.298.543.447.924.447a.98.98 0 00.77-.331v.17c0 .22-.062.39-.187.51s-.3.18-.524.18a.992.992 0 01-.768-.354l-.375.516c.113.146.28.266.501.359.22.093.447.139.68.139.306 0 .574-.054.802-.161.229-.108.406-.264.532-.469.126-.205.19-.446.19-.723V14.33h-.768l-.036.299c-.193-.238-.463-.358-.811-.358-.393 0-.705.149-.936.446-.232.297-.347.688-.347 1.175zm.846.061c0-.33.059-.578.175-.744a.554.554 0 01.479-.249c.252 0 .434.097.548.29v1.333c-.112.193-.296.29-.554.29a.55.55 0 01-.475-.245c-.115-.163-.173-.388-.173-.675zm3.595 1.547v-3.17h-.85v3.17h.85zm-.9-3.99c0 .129.044.234.131.316a.481.481 0 00.344.123.481.481 0 00.345-.123.416.416 0 00.13-.316.415.415 0 00-.129-.314.48.48 0 00-.346-.123.479.479 0 00-.347.123.417.417 0 00-.127.314zm1.829 3.99h.85v-2.549h.63v-.62h-.63v-.256c0-.299.159-.448.477-.448.102 0 .187.009.258.026l.009-.656a1.98 1.98 0 00-.431-.059c-.367 0-.653.099-.857.295-.204.196-.306.472-.306.828v.27h-.472v.62h.472V17.5z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;